module.exports = __webpack_public_path__ + "img/electronic_certificate.1bdbd18f.png";